import Header from "@/features/landing/components/header";
import Footer from "@/features/landing/components/footer";
import { Outlet } from "react-router";

export default function Layout() {
  return (
    <main className="font-body relative flex min-h-screen flex-col bg-white">
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </main>
  );
}
